import React from "react";
import AboutSection from "../../HomeThree/AboutSection";
// import TestimonialSection from "../../HomeThree/TestimonialSection";
// import WorkProcessSection from "../../HomeThree/WorkProcessSection";
// import Layouts from "../../helpers/Layouts";
// import GetInTouchSection from "./GetInTouchSection";
import AboutTeam from "./MainAboutSection";
// import BacktoTopCom from "../../helpers/BackToTopCom";
// import FooterHomeOne from "../../partials/Footers/FooterHomeOne";
// import HeaderHomeOne from "../../partials/Headers/HeaderHomeOne";
// import AboutBackground from "../../../assets/images/about/about-us-bg.jpg";
// import ClientsIndex from "../ImpClients/ClientsIndex";
// import AcademicCollabration from "../../HomeThree/AcademicCollabration";
// import IndustrialPartners from "../../HomeThree/IndustrialPartners";
// import TechnologyAssociations from "../../HomeThree/TechnologyAssociations";
import FeatureSection from "../../HomeOne/FeatureSection";

export default function AboutOne() {
  return (
    <>
      {/* <Layouts
        pageTitle="About Us"
        breadcrumbs={[]}
        background={AboutBackground}
      > */}
      {/* <HeaderHomeOne /> */}
      <section className="featured-section bgs-cover pt-30 rpt-150  rpb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="">
              <div className="section-title text-center mb-35 ">
                {/* <span className="sub-title">WHO WE ARE</span> */}
                <h2 className="blue-text">
                  Specialist in NavIC-based Multi-GNSS Solutions
                  <hr />
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      <AboutSection className="pb-50" />
      <FeatureSection />
      <AboutTeam />
      {/* <ClientsIndex />
      <WorkProcessSection />
      <AcademicCollabration />
      <IndustrialPartners />
      <TechnologyAssociations /> */}
      {/* <TestimonialSection /> */}
      {/* <GetInTouchSection /> */}
      {/* <FooterHomeOne /> */}
      {/* <BacktoTopCom /> */}
      {/* </Layouts> */}
    </>
  );
}
